export * from './modal-info-tab.component';
